<template>
  <div class="login">
    <v-content>
      <v-container fill-height="fill-height">
        <v-layout>
          <v-flex class="login-form">
            <v-card>
              <v-card-text>
                <div class="subheading">
                  <template v-if="options.isLoggingIn">
                    <h4>{{ $t("login.header") }}</h4>
                  </template>
                </div>
                <hr>
                <v-form @submit="onSubmit">
                  <v-text-field
                    v-if="$i18n.locale=='tc'"
                    v-model="form.username"
                    light="light"
                    label="登入名稱"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="form.username"
                    light="light"
                    label="Username"
                  ></v-text-field>
                  <v-text-field
                    v-if="$i18n.locale=='tc'"
                    v-model="form.password"
                    light="light"
                    label="密碼 (6+ 字元)"
                    type="password"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="form.password"
                    light="light"
                    label="Password (6+ characters)"
                    type="password"
                  ></v-text-field>
                  <v-btn v-if="options.isLoggingIn" block="block" type="submit"
                    >Login</v-btn
                  >
                  <v-btn v-else block="block" type="submit">Register</v-btn>
                </v-form>
              </v-card-text>
            </v-card>
            <!-- <div class="mt-4 float-right" v-if="options.isLoggingIn">Don't have an account?<br>
                        <v-btn class="mt-4 float-right" light="light" @click="options.isLoggingIn = false">Register</v-btn>
                    </div>
                    <div class="mt-4 float-right" v-else>Already had an account?<br>
                        <v-btn class="mt-4 float-right" light="light" @click="options.isLoggingIn = true">Login</v-btn>
                    </div> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>
<script>
import moment from "moment";
import { Auth_APIService } from "@/services/Auth_APIService";
const apiService = new Auth_APIService(
  process.env.VUE_APP_BASE_URL + "/api/auth/"
);
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm._backRoute = from.path
    })
  },
  name: "login",
  components: {},
  data: function () {
    return {
      form: {
        username: "",
        email: "",
        password: "",
        confirm_password: "",
      },
      options: {
        isLoggingIn: true,
      },
    };
  },
  mounted: function () {
    var self = this;
    if(self.$cookies.get("auth_token")!="" && self.$cookies.get("auth_token")!=undefined && self.$cookies.get("auth_token")!=null){
      self.$router.push("/announcement");
    }
  },
  methods: {
    onSubmit(evt) {
      var self = this;
      evt.preventDefault();
      self.overlay = true;
      if (self.options.isLoggingIn) {
        //login
        apiService
          .login(self.form.username, self.form.password)
          .then((response) => {
            if (response.status == "fail") {
              alert(response.message);
            } else {
              self.$cookies.set("auth_token", response.token);
              self.$cookies.set("username", response.username);
              self.$cookies.set("user_level", response.user_level);
              self.$cookies.set("school_id", response.school_id);
              self.$cookies.set("school_name", response.school_name);
              self.$cookies.set("school_chi_name", response.school_chi_name);
              let username = response.username;
              let user_level = response.user_level;
              let school_id = response.school_id;
              let school_name = response.school_name;              
              let school_chi_name = response.school_chi_name;
              let auth_token = response.token;
              let admin = false;
              let logged_in = true;
              if(user_level == "ADMIN") admin = true;
              self.$store.state.current.username = response.username;
              self.$store.state.current.user_level = response.user_level;
              self.$store.state.current.logged_in = true;
              self.$store.commit("updateUserInfo", {username, user_level, school_id, school_name, school_chi_name, logged_in, auth_token});
              self.$store.commit("showSnackBar", "Login Success");
              console.log(self._backRoute);
              if(self._backRoute == "/login" || self._backRoute == undefined || self._backRoute == "/" || self._backRoute == "/logout"){
                self.$router.go("/announcement");
                
              }
              else {
                self.$router.go(-1);
              }
            }
          });
      } else {
        //register
        apiService
          .register(
            self.form.username,
            self.form.email,
            self.form.password,
            self.form.confirm_password
          )
          .then((response) => {
            console.log("response");
            console.log(response);
            if (response.status == "fail") {
              alert(response.message);
            } else {
              self.$store.commit(
                "showSnackBar",
                "Register Success! You can login now."
              );
              self.options.isLoggingIn = true;
            }
          });
      }
    },
  },  
};
</script>
<style>
.login-form {
  width: 500px;
}
</style>